<template>
  <div>
    Admin Sites
  </div>
</template>

<script>
export default {
  created() {
    window.scrollTo(0, 0);
  },
};
</script>

<style scoped></style>
